import { ReactNode } from 'react';

import { DefaultTheme } from 'styled-components';
import { withTheme } from 'styled-components';

import { StyBorder, StyContent, StyContainer } from './styles';

type TStartPosition = 'top' | 'bottom' | 'leftRight';

interface ILinearGradientBorder {
  widthMinContent?: boolean;
  children: ReactNode;
  gradientColor?: string;
  gradientColorOnHover?: string;
  keepHoverColorActive?: boolean;
  hasGradient?: boolean;
  hasHover?: boolean;
  startPosition?: TStartPosition;
  customDegPosition?: string;
  maxHeight?: string;
  theme?: DefaultTheme;
}

export const LinearGradientBorder: React.FC<ILinearGradientBorder> = withTheme(
  ({
    children,
    gradientColor = 'rgba(0, 255, 102, 0.8)',
    gradientColorOnHover = 'rgba(0, 255, 102, 1)',
    keepHoverColorActive = false,
    maxHeight,
    hasGradient = true,
    widthMinContent = false,
    hasHover = true,
    startPosition = 'top',
    customDegPosition,
  }: ILinearGradientBorder) => {
    const positionDeg = {
      top: '155deg',
      bottom: '210deg',
      leftRight: '300deg',
    };

    return (
      <StyContainer
        gradientColorOnHover={
          hasGradient ? gradientColorOnHover : 'transparent'
        }
        position={customDegPosition || positionDeg[startPosition]}
        hasHover={hasHover}
        widthMinContent={widthMinContent}
        {...(maxHeight && {
          style: {
            maxHeight,
          },
        })}
      >
        <StyBorder
          gradientColor={hasGradient ? gradientColor : 'transparent'}
          gradientColorOnHover={
            hasGradient ? gradientColorOnHover : 'transparent'
          }
          keepHoverColorActive={keepHoverColorActive}
          position={customDegPosition || positionDeg[startPosition]}
        />
        <StyContent>{children}</StyContent>
      </StyContainer>
    );
  }
);
